import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full mt-[32px] ml-[32px]" }
const _hoisted_2 = { class: "gordita-medium-500-16 text-Text/text_high" }
const _hoisted_3 = { class: "mt-[24px] gordita-400-12 text-Text/text_low" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';
import { useI18n } from 'vue-i18n';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { inject } from 'vue';
import { IKApplicationPersistentData } from '@/services/persistentDataProvider/persistentDataProvider.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'preferencesTab',
  setup(__props) {

const appPersistentData = inject(IKApplicationPersistentData);
const { t } = useI18n();
const { toastMessage } = useNotify();

const resetPersistentData = async () => {
  try {
    await appPersistentData?.resetPersistentData();
    toastMessage(t('userProfile.preferencesTab.successToastText', CONST_NOTIFY.MESSAGE_TYPE.SUCCESS));
  } catch (error) {
    toastMessage(t('userProfile.failureToastText'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('userProfile.preferencesTab.title')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('userProfile.preferencesTab.subTitle')), 1),
        _createVNode(_unref(IncrediButton), {
          size: "small",
          class: "mt-[8px] text-System/app_white",
          design: "primary-green",
          onClick: _withModifiers(resetPersistentData, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('userProfile.preferencesTab.buttonTitle')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}
}

})